import { palette } from '@livable/saas-react-components';
const MuiListSubheader = {
  styleOverrides: {
    root: {
      fontSize: '18px',
      lineHeight: '24px',
      color: palette.shades[800],
      padding: '12px 20px'
    }
  }
};
export default MuiListSubheader;